(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lookstan-policy-guide"] && !Shopify.designMode) return;
  try {
    const policyContents=document.querySelector('.ls-policy-toc');if(policyContents){const headings=document.querySelectorAll('.shopify-policy__body h2,.shopify-policy__body h3');headings.forEach((heading,index)=>{if(!heading.id)heading.id=`lookstan-policy-heading-${index+1}`;const link=document.createElement('a');link.href=`#${heading.id}`;link.textContent=heading.textContent;policyContents.querySelector('nav').append(link);});policyContents.hidden=!headings.length;}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lookstan-size-colors"] && !Shopify.designMode) return;
  try {
    const sizeGrid = document.getElementById('MainContent');
if (sizeGrid) {
  const syncSizeLinks = () => {
    sizeGrid.querySelectorAll('[data-lookstan-size-url]:not([data-lookstan-size-url=""])').forEach(card => {
      const url = card.dataset.lookstanSizeUrl;
      const selected = card.querySelector('.ls-size-color[aria-pressed="true"]');
      if (selected) card.dataset.lookstanSizeImage = selected.dataset.sizeImage;
      card.querySelectorAll('a[href*="/products/"]').forEach(link => {
        if (link.getAttribute('href') !== url) link.setAttribute('href', url);
      });
      const image = card.querySelector('.card__media img');
      if (image && card.dataset.lookstanSizeImage) {
        if (image.getAttribute('src') !== card.dataset.lookstanSizeImage) image.setAttribute('src', card.dataset.lookstanSizeImage);
        if (image.hasAttribute('srcset')) image.removeAttribute('srcset');
      }
    });
  };
  sizeGrid.addEventListener('click', event => {
    const button = event.target.closest('.ls-size-color');
    if (!button) return;
    event.preventDefault();
    const card = button.closest('[data-lookstan-size-url]');
    card.dataset.lookstanSizeUrl = button.dataset.sizeUrl;
    card.dataset.lookstanSizeImage = button.dataset.sizeImage;
    card.querySelectorAll('.ls-size-color').forEach(option => option.setAttribute('aria-pressed', String(option === button)));
    card.querySelector('.ls-size-colors__selection').textContent = button.dataset.sizeLabel;
    syncSizeLinks();
  });
  syncSizeLinks();
  new MutationObserver(syncSizeLinks).observe(sizeGrid, {subtree: true, childList: true, attributes: true, attributeFilter: ['href', 'src', 'srcset']});
}
  } catch(e) { console.error(e); }
})();

})();
